import { SideNavItem } from 'foundations-components/transitional/components/SideNav';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useHasGate } from '../../accounts/accountsQueries';
import { AssignPlaylistModalTrigger } from '../../playlistAssignments/components/AssignPlaylistModalTrigger';
import { jsx as _jsx } from "react/jsx-runtime";
const ASSIGN_ANY_CONTENT_GATE = 'AcademyAchievements::AssignAnyContentMyTeam';
const ASSIGN_LABEL_BY_TYPE = {
  TRACK: 'academyCommon.cardMenu.assignCourse',
  LESSON: 'academyCommon.cardMenu.assignLesson',
  SHORT_FORM_CONTENT: 'academyCommon.cardMenu.assignVideo',
  PLAYLIST: 'academyCommon.playlistAssignments.assignPlaylist',
  LEARNING_PATH: 'academyCommon.playlistAssignments.assignPlaylist'
};
const CardMenuAssignContentOption = ({
  contentId,
  contentType,
  render
}) => {
  const {
    hasGate
  } = useHasGate(ASSIGN_ANY_CONTENT_GATE);
  if (!hasGate) {
    return null;
  }
  const label = /*#__PURE__*/_jsx(FormattedMessage, {
    message: ASSIGN_LABEL_BY_TYPE[contentType]
  });
  return /*#__PURE__*/_jsx(AssignPlaylistModalTrigger, {
    playlistId: contentId,
    renderTrigger: ({
      openModal
    }) => {
      if (render) {
        return render(label, openModal);
      }
      return /*#__PURE__*/_jsx(SideNavItem, {
        onClick: openModal,
        role: "navigation-item",
        title: label
      });
    }
  });
};
export default CardMenuAssignContentOption;